import { Box, styled } from "@mui/material"



export const StandardPadding = styled(Box)`
    padding-top: 60px;
    padding-bottom: 60px;
    ${props => props.theme.breakpoints.up("md")} {
        padding-top: 100px;
        padding-bottom: 100px;
    }
`;

export const StandardPaddingTop = styled(Box)`
    padding-top: 60px;
${props => props.theme.breakpoints.up("md")} {
    padding-top: 100px;
}
`;

export const StandardPaddingBottom = styled(Box)`
    padding-bottom: 60px;
${props => props.theme.breakpoints.up("md")} {
    padding-bottom: 100px;
}
`;